<template v-slot:body>
    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
        <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
            <b-row>
                <b-col>
                    <b-overlay>
                        <table class="table table-bordered">
                            <tr class="bg-light">
                                <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                <th>{{ $t('production_store.pro_category') }}</th>
                                <th>{{ $t('production_store.pro_sub_category') }}</th>
                                <th>{{ $t('production_store.pro_name') }}</th>
                                <th>{{ $t('production_store.pro_unit') }}</th>
                                <th>{{ $t('production_store.target_quantity') }}</th>
                                <th>{{ $t('production_store.recommend_quantity') }}</th>
                            </tr>
                            <tr v-for="(item, index) in dataArray.details" :key="index">
                                <td>{{ $n(index + 1) }}</td>
                                <td>{{ productCategoryById(item.category_id) }}</td>
                                <td v-if="item.sub_category_id">{{ productSubCategoryById(item.sub_category_id) }}</td>
                                <td v-else></td>
                                <td>{{ productNameById(item.product_id) }}</td>
                                <td>{{ unitNameById(item.unit_id) }}</td>
                                <td vid="firstValue">{{ item.target_quantity }}</td>
                                <td>
                                    <ValidationProvider name="Recommended Quantity">
                                        <b-form-group slot-scope="{ valid, errors }">
                                            <b-form-input
                                                type="number"
                                                v-model="item.approve_quantity"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </td>
                            </tr>
                        </table>
                    </b-overlay>
                </b-col>
            </b-row>
            <div class="row">
                <div class="col text-right">
                    <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.save') }}</b-button>
                                                    &nbsp;
                    <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
                </div>
            </div>
        </b-form>
    </ValidationObserver>
</template>
<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { productionTargetById, productionTargetRequestUpdateApi } from '../../api/routes'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            dataArray: {
                details: []
            },
            sl: 0,
            subCategoryList: [],
            productList: [],
            productUnitList: []
        }
    },
    computed: {
        categoryList: function () {
            return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    created () {
        if (this.id) {
            this.getTargetInfoData(this.id)
        }
    },
    methods: {
        cancel () {
            this.$bvModal.hide('modal-2')
        },
        async getTargetInfoData (id) {
          const result = await RestApi.getData(productionServiceBaseUrl, productionTargetById + '/' + id)
          if (result.success) {
            this.dataArray.details = result.data.production_target_details
          }
        },
        productCategoryById (id) {
            const category = this.productCommonObj.productCategoryList.find(category => category.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        productSubCategoryById (id) {
            const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
            if (this.$i18n.locale === 'bn') {
                return subCategory.text_bn
            } else {
               return subCategory.text_en
            }
        },
        productNameById (id) {
            const product = this.productCommonObj.productList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
               return product.text_en
            }
        },
        unitNameById (id) {
            const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
            if (this.$i18n.locale === 'bn') {
                return unit.text_bn
            } else {
               return unit.text_en
            }
        },
        async saveData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            result = await RestApi.putData(productionServiceBaseUrl, `${productionTargetRequestUpdateApi}/${this.id}`, this.dataArray)
            if (result.success) {
                this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-2')
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}
</script>
